export const formatToDecimal = (value) => {
    if (!value) return "";
    
    // Remove the inch symbol if it exists
    value = value.toString().replace('"', '');
  
    // Check if there's a fraction
    if (value.includes('/')) {
      const parts = value.split(' ');
      const wholePart = parseInt(parts[0]) || 0;
  
      if (parts.length > 1) {
        const fractionParts = parts[1].split('/');
        const numerator = parseInt(fractionParts[0]) || 0;
        const denominator = parseInt(fractionParts[1]) || 1;
  
        // Calculate decimal value
        return (wholePart + (numerator / denominator)).toString();
      }
      return wholePart.toString();
    }
  
    return value;
  };
  
export const formatToFractional = (value) => {
  // Convert value to string and handle null/undefined
  if (value == null) return "";
  const stringValue = String(value);

  // Remove extra spaces and trim
  const cleanedValue = stringValue.replace(/\s+/g, ' ').trim();

  // Regular expression to match imperial format (e.g., "40 5/16" or "5/16")
  const imperialRegex = /^(\d+)?\s*(\d+\/\d+)"?$/;
  const match = cleanedValue.match(imperialRegex);

  if (match) {
    const wholePart = match[1] ? parseInt(match[1]) : 0;
    const fraction = match[2];

    // List of valid fractions
    const validFractions = [
      "1/16", "1/8", "3/16", "1/4", "5/16", "3/8", "7/16",
      "1/2", "9/16", "5/8", "11/16", "3/4", "13/16", "7/8", "15/16"
    ];

    // If the fraction is already valid, return the cleaned input with inch symbol
    if (validFractions.includes(fraction)) {
      return wholePart > 0 ? `${wholePart} ${fraction}"` : `${fraction}"`;
    }

    // Convert invalid fraction to decimal and then to closest valid fraction
    const [numerator, denominator] = fraction.split('/').map(Number);
    const decimalValue = numerator / denominator;
    const closestFraction = decimalToFraction(decimalValue);

    return wholePart > 0 ? `${wholePart} ${closestFraction}"` : `${closestFraction}"`;
  }

  // If input is not in imperial format, proceed with original decimal conversion
  const decimalValue = parseFloat(cleanedValue);
  if (isNaN(decimalValue)) {
    return cleanedValue;
  }

  // Get the whole part
  const wholePart = Math.floor(decimalValue);

  // Get the decimal part
  const decimalPart = decimalValue - wholePart;

  // If no decimal part, return just the whole number with inch symbol
  if (decimalPart === 0) {
    return `${wholePart}"`;
  }

  // Convert the decimal part to a fraction
  const fraction = decimalToFraction(decimalPart);

  // Return the whole part with the fractional part
  return `${wholePart} ${fraction}"`;
};

// Helper function to convert decimal to the nearest common fraction
const decimalToFraction = (decimal) => {
  // Common fractions for imperial measurements (denominators: 2, 4, 8, 16)
  const fractions = [
    { fraction: "1/16", value: 1 / 16 },
    { fraction: "1/8", value: 2 / 16 },
    { fraction: "3/16", value: 3 / 16 },
    { fraction: "1/4", value: 4 / 16 },
    { fraction: "5/16", value: 5 / 16 },
    { fraction: "3/8", value: 6 / 16 },
    { fraction: "7/16", value: 7 / 16 },
    { fraction: "1/2", value: 8 / 16 },
    { fraction: "9/16", value: 9 / 16 },
    { fraction: "5/8", value: 10 / 16 },
    { fraction: "11/16", value: 11 / 16 },
    { fraction: "3/4", value: 12 / 16 },
    { fraction: "13/16", value: 13 / 16 },
    { fraction: "7/8", value: 14 / 16 },
    { fraction: "15/16", value: 15 / 16 },
  ];

  // Find the closest fraction
  let closestFraction = fractions[0].fraction;
  let minDifference = Math.abs(decimal - fractions[0].value);

  for (let i = 1; i < fractions.length; i++) {
    const difference = Math.abs(decimal - fractions[i].value);
    if (difference < minDifference) {
      minDifference = difference;
      closestFraction = fractions[i].fraction;
    }
  }

  return closestFraction;
};
// Helper function to compute the greatest common divisor (GCD)
const greatestCommonDivisor = (a, b) => {
while (b) {
  [a, b] = [b, a % b];
}
return a;
};
//==========
export function toDecimal(imperial) {
    // Ensure the input is a string, or convert it if possible
    if (typeof imperial !== "string") {
        //console.error("Invalid input: imperial must be a string.");
        return 0; // Default to 0 or handle as necessary
    }

    // Remove the double quotes (") and trim spaces
    imperial = imperial.replace('"', '').trim();

    // Initialize result
    let result = 0;

    // Check if there are feet ('), split by space to handle cases like "6' 8"
    if (imperial.includes("'")) {
        const [feetPart, inchesPart] = imperial.split("'").map((part) => part.trim());

        // Convert feet to inches and add to result
        if (feetPart) {
            result += parseInt(feetPart) * 12;
        }

        // Process the inches part if it exists
        if (inchesPart) {
            imperial = inchesPart; // Remaining part to process as inches
        } else {
            return result; // Only feet provided, return result
        }
    }

    // Split the inches part into whole number and fraction
    const [whole, fraction] = imperial.split(" ");

    // Add the whole number part (inches)
    if (whole) {
        result += parseInt(whole);
    }

    // Add the fractional part (if exists)
    if (fraction) {
        const [numerator, denominator] = fraction.split("/");
        if (denominator) {
            result += parseInt(numerator) / parseInt(denominator);
        }
    }

    return result;
}

  
export function convertToImperial(metric) {
    const mm = typeof metric === 'string' ? parseFloat(metric) : metric;

    if (isNaN(mm) || mm < 0) {
        return 'Invalid input';
    }

    // Convert mm to total inches
    const totalInches = mm / 25.4;

    // Calculate feet and remaining inches
    const feet = Math.floor(totalInches / 12); // Get whole feet
    let inches = totalInches % 12; // Get remaining inches (with decimals)

    // Convert fractional inches to nearest 1/16 for precision
    const fractionPrecision = 16; // 1/16 inch precision
    const fractionalPart = inches % 1; // Get only the fractional part
    const numerator = Math.round(fractionalPart * fractionPrecision);
    const denominator = fractionPrecision;

    // Simplify the fraction
    let simplifiedNumerator = numerator;
    let simplifiedDenominator = denominator;
    while (simplifiedNumerator % 2 === 0 && simplifiedDenominator % 2 === 0) {
        simplifiedNumerator /= 2;
        simplifiedDenominator /= 2;
    }

    // Update the whole inches
    inches = Math.floor(inches);

    // Handle edge case: fractional part rounds to 1 inch
    if (simplifiedNumerator === simplifiedDenominator) {
        inches += 1;
        simplifiedNumerator = 0;
    }

    // Handle edge case: inches rounds to 12
    if (inches === 12) {
        return `${feet + 1}'`;
    }

    // Build the formatted string
    let result = `${feet}' ${inches}"`;
    if (simplifiedNumerator > 0) {
        result += ` ${simplifiedNumerator}/${simplifiedDenominator}"`;
    }

    return result;
}

// Convert metric (mm) to imperial (feet and inches)
export function convertToImperial1(metric) {
    // Convert input to number if it's a string
    const mm = typeof metric === 'string' ? parseFloat(metric) : metric;
    
    if (isNaN(mm) || mm < 0) {
        return 'Invalid input';
    }

    // Convert mm to total inches
    const totalInches = mm / 25.4;
    
    // Calculate feet
    const feet = Math.floor(totalInches / 12);
    
    // Calculate remaining inches
    let inches = totalInches % 12;
    
    // Round to nearest 1/4 inch
    inches = Math.round(inches * 4) / 4;
    
    // If inches rounds to 12, increment feet and set inches to 0
    if (inches === 12) {
        return `${feet + 1}'`;
    }
    
    // Format the output
    if (feet === 0) {
        return inches === 0 ? '0"' : `${inches}"`;
    }
    
    return inches === 0 ? `${feet}'` : `${feet}' ${inches}"`;
}

// Convert imperial (feet and inches) to metric (mm)
export function convertToMetric(imperial) {
    if (typeof imperial !== 'string') {
        return 'Input must be a string';
    }

    // Remove extra spaces and normalize format
    const cleanedInput = imperial.trim().replace(/\s+/g, ' ');
    
    // Handle simple numeric inputs (treat as inches)
    if (/^\d+$/.test(cleanedInput)) {
        return parseFloat(cleanedInput) * 25.4;
    }

    let totalInches = 0;
    
    // First check for feet marker
    if (cleanedInput.includes("'") || cleanedInput.includes("’")) {
        const feetMatch = cleanedInput.match(/(\d+)['’]/);
        const inchMatch = cleanedInput.match(/(\d*\s*\d*\/\d*)["”]/);
        
        // Calculate feet portion
        if (feetMatch) {
            totalInches += parseInt(feetMatch[1]) * 12;
        }
        
        // Calculate inches portion
        if (inchMatch) {
            const inchStr = inchMatch[1].trim();
            if (inchStr.includes('/')) {
                const [numerator, denominator] = inchStr.split('/').map(num => parseInt(num));
                totalInches += numerator / denominator;
            } else if (inchStr) {
                totalInches += parseFloat(inchStr);
            }
        }
    } else {
        // Handle format like "1 1/2"" (whole inches and fraction)
        const parts = cleanedInput.replace('"', '').trim().split(' ');
        if (parts.length === 2 && parts[1].includes('/')) {
            totalInches += parseInt(parts[0]) || 0;
            const [numerator, denominator] = parts[1].split('/').map(num => parseInt(num));
            totalInches += numerator / denominator;
        } else if (cleanedInput.match(/^\d*\s*\d*\/\d*["”]$/)) {
            // Handle "1/2"" format
            const fractionMatch = cleanedInput.match(/(\d*\/\d*)["”]/);
            if (fractionMatch) {
                const [numerator, denominator] = fractionMatch[1].split('/').map(num => parseInt(num));
                totalInches += numerator / denominator;
            }
        } else {
            // Handle plain inches
            totalInches += parseFloat(cleanedInput.replace('"', '')) || 0;
        }
    }
    
    // Convert to mm and round to 1 decimal place
    return Math.round(totalInches * 25.4 * 10) / 10;
}
